<template>
  <CHeader class="d-flex justify-content-between sp-margin" fixed light>

    <CToggler in-header class="ml-3 sp-margin-b d-lg-none" v-c-emit-root-event:toggle-sidebar-mobile />
    <CToggler in-header class="ml-3 d-md-down-none" v-c-emit-root-event:toggle-sidebar />
    <div v-if="inicio_semana" class="d-flex flex-grow-1 align-items-center h4 mb-0 hide-in-mobile">{{inicio_semana}}</div>
    <CHeaderNav class="mr-4 sp-margin-ul">
      <div class="root-location">
        <!-- <label>Ubicación raíz:</label> -->
        <v-select
          class="root-location-input"
          v-model="ubicacionRaiz"
          :options="ubicaciones"
          :loading="isLoadingPage"
          placeholder="Ubicación raíz"
        >
          <template #open-indicator="{ attributes }">
            <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
          </template>
          <template #no-options>Sin resultados.</template>
        </v-select>
      </div>
      <div class="d-flex flex-column">
        <span class="clave">{{ clave_empresa }}</span>
        <span class="clave sp-font-size">{{ userName }}</span>
      </div>
      <TheHeaderDropdownAccnt />
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
    vSelect,
  },

  data() {
    return {
      inicio_semana:"",
      ubicacion: null,
      isLoadingPage: false,
      cultivos: [],
      cultivo: null,
      ubicaciones2: [],
      ubicacion2: null,
      test: 1
    };
  },

  created() {
    this.isLoadingPage = true;
    // // console.log(moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59"));
    // if (!this.ubicacionesRaiz.length) {
    const ubi = [
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }),
      this.$store.dispatch("customHTTP", { schema: "cultivos" }),
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaiz,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }),
      this.$store.dispatch("customHTTP", { schema: "configuracion", filter: {
        where: [{
          field: 'payload->parametro',
          operator: "=",
          value: "primer_dia_semana"
        }]
      } }),
    ];
    Promise.all(ubi)
      .then(([ubicaciones, cultivos, ubicacionesAll,configuraciones]) => {
        // console.log(ubicaciones.data);
        if(configuraciones.data.length){
          this.inicio_semana = `Inicio de semana: ${[
              'Domingo',
              'Lunes',
              'Martes',
              'Miércoles',
              'Jueves',
              'Viernes',
              'Sábado'][configuraciones.data[0].payload.valor]}`

        } else {
          this.inicio_semana = ""
        }
        this.ubicaciones = ubicaciones.data.map(ubi => {
          return { value: ubi.id, label: ubi.payload.nombre };
        });
        this.cultivos = cultivos.data.map(cul => {
          return { value: cul.id, label: cul.payload.nombre };
        });
        this.ubicaciones2 = ubicacionesAll.data.map(ubi => {
          return { value: ubi.id, label: ubi.payload.nombre };
        });
        // console.log(values);
        // this.ubicaciones = ubicaciones.data;
      })
      .catch(rej => console.log(rej.message))
      .finally(() => (this.isLoadingPage = false));
  },

  computed: {
    clave_empresa() {
      return this.$store.state.clave_empresa
        ? this.$store.state.clave_empresa.replace("_", " ")
        : "";
    },
    userName() {
      return this.$store.state.userName;
    },
    ubicacionesRaiz() {
      return this.$store.state.rootLocations;
    },
    datesGraph() {
      return this.$store.state.dateGraphs;
    },
    ubicaciones: {
      get() {
        const getIdsRoot = this.$store.state.credenciales
          .filter((ff) => {
            return /@catalogo:schema=ubicaciones\|.*payload.raiz_id=/i.test(ff);
          })
          .map((m) => m.split("payload.raiz_id=")[1]);
        const isAll = getIdsRoot.some((s) => s === "*");
        return this.$store.state.rootLocations.filter(
          (ff) => isAll || getIdsRoot.includes(`${ff.value}`)
        );
      },
      set(value) {
        this.$store.dispatch("setRootLocations", value);
      }
    },
    ubicacionRaiz: {
      get() {
        return this.$store.state.rootLocation;
      },
      set(value) {
        this.$store.dispatch("setRootLocation", value);
      }
    },
    cropGraphs: {
      get() {
        return this.$store.state.cropGraphs;
      },
      set(value) {
        this.$store.dispatch("setCropGraph", value);
      }
    },
    locationGraphs: {
      get() {
        return this.$store.state.locationGraphs || this.$store.state.rootLocation;
      },
      set(value) {
        this.$store.dispatch("setLocationGraph", value);
      }
    },
    // dates: {
    //   get() {
    //     return this.$store.state.dateGraphs;
    //   },
    //   set(value) {
    //     this.$store.dispatch("setRootLocation", value);
    //   }
    // },
    isIndicator() {
      let path = this.$route.path.substring(1, 12);
      if (path == "indicadores") {
        return true;
      } else {
        return false;
      }
    },
    isAnalisis() {
      let path = this.$route.path.substring(9, 17);

      if (path == "analisis") {
        return true;
      } else {
        return false;
      }
      // return this.$route.path.substring(9, 18);
      // // console.log(path);
    },
    isAdmin() {
      let path = this.$route.path.substring(13, 28);
      console.log(path);
      if (path == "administrativos") {
        return true;
      } else {
        return false;
      }
    },
    isAdminText() {
      let path = this.$route.path.substring(13, 28);

      if (path == "administrativos") {
        return "Administrativos";
      } else {
        return "Operativos";
      }
    },
    page() {
      console.log(this.$route.name);
      return this.$route.name;
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateLocations();
    }
    // page: function() {
    //   this.changeIsActive();
    // }
  },

  methods: {
    changeIsActive(navItem) {
      console.log(this.page);
      if (this.page == navItem) {
        return true;
      } else {
        return false;
      }
      // switch (this.page) {
      //   case this.page == navItem:
      //     return true;
      //   case "IngresosAcumulados":
      //     return true;
      //   case "Egresos":
      //     return true;
      //   case "EgresosAcumulados":
      //     return true;
      //   case "Comparativa":
      //     return true;
      //   case "ProduccionIndicador":
      //     return true;
      //   case "ProduccionIndicadorAcumulada":
      //     return true;
      //   case "CantidadAct":
      //     return true;
      //   // break;

      //   default:
      //     break;
      // }
    },
    changeRoute() {
      console.log("hola");
      this.$route.push({ name: this.page });
    },
    changeDate(e) {
      console.log(e);
      const datesValues = [
        moment(e.start).format("YYYY-MM-DD"),
        moment(e.end).format("YYYY-MM-DD")
      ];
      this.$store.dispatch("setDateGraph", datesValues);
    },
    updateLocations() {
      this.isLoadingPage = true;
      // // console.log(moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59"));
      // if (!this.ubicacionesRaiz.length) {
      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->raiz_id",
                value: this.ubicacionRaiz,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      Promise.all(ubi)
        .then(([ubicaciones]) => {
          // console.log(ubicaciones.data);
          this.ubicaciones2 = ubicaciones.data.map(ubi => {
            return { value: ubi.id, label: ubi.payload.nombre };
          });
          // console.log(values);
          // this.ubicaciones = ubicaciones.data;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoadingPage = false));
    }
  }
};
</script>

<style scoped>
.clave {
  color: #3c4b64 !important;
  font-weight: 500;
}
.sp-font-size {
  font-size: 12px;
  font-weight: 400;
}
.root-location {
  width: 180px;
  margin: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selector-input {
  width: 250px;
  margin-left: 0.5rem;
}
.selector-input-2 {
  width: 180px;
  margin: 0 0.5rem;
}
.root-location-input {
  width: 100%;
}
.margi-dates {
  margin: 0 0.5rem;
}
.cursor-p {
  cursor: pointer;
}
.sp-margin-b {
}
.sp-margin-ul {
}
@media (max-width: 700px) {
  .selector-input {
    width: 200px;
    margin-left: 0.5rem;
  }
  .selector-input-2 {
    width: 200px;
    margin: 0 0.5rem;
  }
  .margi-dates {
    margin: 0 0.4rem;
  }
}
@media (max-width: 620px) {
  .selector-input {
    width: 200px;
    margin-right: 0.4rem;
  }
  .selector-input-2 {
    width: 200px;
    margin: 0.4rem;
  }
}
@media (max-width: 580px) {
  .margi-dates {
    margin: 0 0.3rem;
  }
}
@media (max-width: 450px) {
  .root-location {
    width: 120px;
    margin: 0 0.2rem;
  }
  .sp-margin-b {
    margin-left: 0.5rem !important;
  }
  .sp-margin-ul {
    margin-right: 0.5rem !important;
  }
}
@media (max-width: 360px) {
  div.hide-in-mobile{
    display: none !important;
  }
  .root-location {
    width: 100px;
    margin: 0 0.2rem;
  }
  .sp-font-size {
    font-size: 10px;
    font-weight: 400;
  }
  .sp-margin-b {
    margin-left: 0.1rem !important;
  }
  .sp-margin-ul {
    margin-right: 0.1rem !important;
  }
  .clave {
    font-size: 11px;
  }
}

</style>
